/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anprivatversicherung2Inputs */



/**

* @param {_Field_Anprivatversicherung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_anprivatversicherung2 = /** @type {((inputs?: _Field_Anprivatversicherung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anprivatversicherung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Privatversicherung")
});
export { _field_anprivatversicherung2 as "_field_anPrivatVersicherung" }